package com.anjuros.website.redesign.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.styles.RdFooterColumnStyle
import com.anjuros.website.redesign.styles.RdFooterEmailStyle
import com.anjuros.website.redesign.styles.RdFooterGridStyle
import com.anjuros.website.redesign.styles.RdFooterHeadingStyle
import com.anjuros.website.redesign.styles.RdFooterLegalStyle
import com.anjuros.website.redesign.styles.RdFooterLogoStyle
import com.anjuros.website.redesign.styles.RdFooterStyle
import com.anjuros.website.redesign.styles.RdFooterTaglineStyle
import com.anjuros.website.redesign.styles.RdWrapStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.templates.selection.util.Constants.CLIENTS_EMAIL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

private val DesignLinks = listOf(
    RdText.FOOTER_ELECTRICIAN to RdRoute.ELECTRICIAN,
    RdText.FOOTER_DECORATOR to RdRoute.DECORATOR,
    RdText.FOOTER_HANDYMAN to RdRoute.HANDYMAN,
    RdText.FOOTER_ALL_DESIGNS to RdRoute.DESIGNS,
)

private val ServiceLinks = listOf(
    RdText.FOOTER_PRICING to RdRoute.PRICING,
    RdText.FOOTER_PORTAL to RdRoute.PORTAL,
    RdText.FOOTER_SEO to RdRoute.SEO,
    RdText.FOOTER_CONTACT_FORMS to RdRoute.CONTACT_FORMS,
)

private val CompanyLinks = listOf(
    RdText.FOOTER_ABOUT to RdRoute.ABOUT,
    RdText.FOOTER_BLOG to RdRoute.BLOG,
    RdText.FOOTER_FAQ to RdRoute.FAQ,
    RdText.FOOTER_PRIVACY to RdRoute.PRIVACY,
)

@Composable
fun SiteFooter() {
    Footer(RdFooterStyle.toModifier().toAttrs()) {
        Div(RdWrapStyle.toModifier().toAttrs()) {
            Div(RdFooterGridStyle.toModifier().toAttrs()) {
                Div {
                    RdHomeLink { RdPicture(RdImage.LOGO, LocalText(RdText.LOGO_ALT), modifier = RdFooterLogoStyle.toModifier()) }
                    P(RdFooterTaglineStyle.toModifier().toAttrs()) { Text(LocalText(RdText.FOOTER_TAGLINE)) }
                }
                FooterColumn(RdText.FOOTER_DESIGNS, DesignLinks)
                FooterColumn(RdText.FOOTER_SERVICES, ServiceLinks)
                FooterColumn(RdText.FOOTER_COMPANY, CompanyLinks)
                // Its own grid item: full width under the columns on phones and tablets, under Company on desktop.
                Div(RdFooterEmailStyle.toModifier().toAttrs()) {
                    A("mailto:$CLIENTS_EMAIL") {
                        RdIcons.Mail(size = 18)
                        Text(CLIENTS_EMAIL)
                    }
                    RdCopyButton(CLIENTS_EMAIL, RdText.COPY_EMAIL_LABEL)
                }
            }
            Div(RdFooterLegalStyle.toModifier().toAttrs()) {
                Span { Text(LocalText(RdText.FOOTER_COPYRIGHT)) }
                Span { Text(LocalText(RdText.FOOTER_STRAPLINE)) }
            }
        }
    }
}

@Composable
private fun FooterColumn(title: RdText, links: List<Pair<RdText, String>>) {
    Div(RdFooterColumnStyle.toModifier().toAttrs()) {
        H4(RdFooterHeadingStyle.toModifier().toAttrs()) { Text(LocalText(title)) }
        Ul {
            links.forEach { (text, path) ->
                Li { RdLink(path) { Text(LocalText(text)) } }
            }
        }
    }
}
